import { theme } from '../../../../../generated/theme';
import { InfoContainerColors } from '../../../../common/InfoContainer';

export const terminalInfoContainerColors: InfoContainerColors = {
  backgroundColor: theme.colors.hslLightPurple,
  borderColor: theme.colors.border.hslCommuterTrainPurple,
};
